import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading1,
  JustifyContent,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { ContentstackImage } from '../ContentstackImage'
import { getRenderableRichTextBlocks, RichText } from '../../components/RichText'
import type { HeroFields } from './types'

import { CtaLink, mapCmsCta } from '../../cta'
import type { OnTriggerPromoCode } from '../../cta'

export type HeroProps = HeroFields & {
  onTriggerPromocode?: OnTriggerPromoCode
}

function HeroBody({ body }: { body?: HeroFields['body'] }) {
  if (getRenderableRichTextBlocks(body).length === 0) {
    return null
  }

  return (
    <Box paddingBottom={[4]} paddingRight={[null, 4]}>
      <RichText
        content={body}
        paragraphGapSize={4}
        renderParagraph={({ children, key }) => (
          <Body2 key={key} size={4} textAlign={TextAlign.Center} style={{ whiteSpace: 'pre-wrap' }}>
            {children}
          </Body2>
        )}
      />
    </Box>
  )
}

export function Hero({
  heading,
  body,
  cta,
  onTriggerPromocode,
  image,
  image_alt,
  image_mobile,
}: HeroProps) {
  const ctaLink = mapCmsCta(cta, onTriggerPromocode)

  return (
    <Box>
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        paddingH={[4, 8, 20]}
        paddingV={[8, 16]}
        paddingBottom={[12, 16]}
      >
        <Box maxWidth="512px">
          <Box paddingBottom={3}>
            <Heading1 textAlign={TextAlign.Center}>{heading}</Heading1>
          </Box>

          <HeroBody body={body} />

          {ctaLink && (
            <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
              <CtaLink cta={ctaLink} />
            </Box>
          )}
        </Box>
      </Box>

      {image?.url && (
        <ContentstackImage
          fit="cover"
          width="100%"
          height={['120px', '141px', null, '160px']}
          sizes="100vw"
          alt={image_alt || ''}
          src={image.url}
          mobileSrc={image_mobile?.url}
        />
      )}
    </Box>
  )
}
